<template>
    <v-tooltip bottom>
        <v-select slot="activator"
                v-model="pack"
                :items="values"
                :label="$t('Packaging')"
                item-value="code"
                return-object
                :hint="showHint"
                :outline="outline"
                :error-messages="errorMessages"
                :rules="rules"
                persistent-hint
                @change="packageChanged"
                class="chip-container">

            <template slot="selection" slot-scope="{ item, selected }">
                <v-chip small label>
                    <v-avatar dark>
                        <v-icon small>{{ iconAndHint(item).icon }}</v-icon>
                    </v-avatar>
                    {{ item.code }}
                </v-chip>
            </template>

            <template slot="item" slot-scope="{ item, tile }">
                <v-list-tile-avatar color="indigo" class="headline font-weight-light white--text">
                    <v-tooltip bottom>
                        <v-icon slot="activator" color="white">{{ iconAndHint(item).icon }}</v-icon>
                        {{ iconAndHint(item).text }}
                    </v-tooltip>
                </v-list-tile-avatar>
                <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                    <v-list-tile-sub-title>
                        <span class="mr-2 font-weight-light">{{ item.code }}</span>
                        {{ item.description }}
                    </v-list-tile-sub-title>
                </v-list-tile-content>
            </template>
        </v-select>
        <span>{{ pack ? pack.name + (pack.description ? ', ' + pack.description : '') : '' }}</span>
    </v-tooltip>
</template>

<script>
import { shipments }  from "../resources";
import { mapGetters } from "vuex";
export default {
    name : 'v-package-selector',
    props: [ 'value', 'outline', 'values', 'rules', 'errors', 'acceptChange' ],
    data() {
        return {
            pack: {},
            hideErrors: false
        };
    },
    computed: {
        ...mapGetters(['globalConfig']),
        showHint() {
            return this.iconAndHint(this.pack).text;
        },
        errorMessages() {
         if (this.hideErrors)
           return null;
         return this.errors;
        }
    },
    watch: {
        value: {
          handler() {
            this.setPackage();
          },
          immediate: true
        },
        values: {
          handler() {
            this.setPackage();
          },
          immediate: true
        },
        errors(val) {
          this.hideErrors = false;
        }
    },
    methods: {
        packageChanged() {
            if (this.acceptChange && !this.acceptChange(this.pack)) {
                const rejected = this.pack;
                // Let v-select receive the rejected value before restoring its internal selection.
                this.$nextTick(() => {
                    if (this.pack === rejected) {
                        this.pack = this.values.find(item => item.code === this.value) || {};
                    }
                });
                return;
            }
            this.$emit("input", !!this.pack && !!this.pack.code ? this.pack.code : null);
            this.$emit("pallet", this.pack);
            if (!!this.pack.code)
              this.hideErrors = true
        },
        setPackage() {
            // Update the pack with the relevant package from the list
            if (!!this.value && this.value !== this.pack.code && Array.isArray(this.values)) {
              this.pack = this.values.find(e => e.code === this.value) || {};
            }
        },
        iconAndHint(item) {
            let icon = 'fa-box';// !item.standard && !item.small
            let text = item.name || '';
            if (item.standard) {
                icon = 'fa-pallet';
                text = this.$t('Pallet');
                if (typeof item.size_x === 'number' && typeof item.size_y === 'number') {
                    text += ' ' + item.size_x.toFixed(1) + 'x' + item.size_y.toFixed(1);
                    if (typeof item.size_z === 'number') {
                        text += 'x' + item.size_z.toFixed(1);
                    }
                }
            }
            else
            if (item.small) {
                icon = 'fa-envelope';
                text = this.$t('Small package');
            }
            return {
                icon,
                text
            };
        }
    },
}
</script>
<style scoped>
.chip-container >>> .v-select__slot {
    position: relative;
    overflow: hidden;
}
.chip-container >>> .v-select__slot:after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 100%;
    background-image: linear-gradient(to right, #fff0 0%, #fff 100%);
}
</style>